import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  Input,
} from '@angular/core';

@Directive({
  selector: '[uiRipple]',
  standalone: true,
})
export class UIRippleDirective {
  @Input() set rippleDisabled(value: boolean) {
    this._rippleDisabled = value;
    if (!this._rippleDisabled) {
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        'position',
        'relative'
      );
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        'overflow',
        'hidden'
      );
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        'padding',
        '2px'
      );
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        'border-radius',
        '50%'
      );
    }
  }
  @Input() rippleColor = 'rgba(0, 0, 0, 0.15)';
  @Input() rippleDuration = 600; // milliseconds

  private _rippleDisabled?: boolean;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this._rippleDisabled) {
      return;
    }

    const hostElement = this.elementRef.nativeElement;
    const rect = hostElement.getBoundingClientRect();
    const diameter = Math.max(rect.width, rect.height);

    const ripple = this.renderer.createElement('span');
    this.renderer.setStyle(ripple, 'width', `${diameter}px`);
    this.renderer.setStyle(ripple, 'height', `${diameter}px`);
    this.renderer.setStyle(ripple, 'border-radius', '50%');
    this.renderer.setStyle(ripple, 'position', 'absolute');
    this.renderer.setStyle(ripple, 'pointer-events', 'none');
    this.renderer.setStyle(ripple, 'background', this.rippleColor);
    this.renderer.setStyle(
      ripple,
      'transform',
      'translate(-50%, -50%) scale(0)'
    );
    this.renderer.setStyle(
      ripple,
      'transition',
      `transform ${this.rippleDuration}ms ease, opacity ${this.rippleDuration}ms ease`
    );

    const top = event.clientY - rect.top;
    const left = event.clientX - rect.left;
    this.renderer.setStyle(ripple, 'top', `${top}px`);
    this.renderer.setStyle(ripple, 'left', `${left}px`);

    this.renderer.appendChild(hostElement, ripple);

    requestAnimationFrame(() => {
      this.renderer.setStyle(
        ripple,
        'transform',
        `translate(-50%, -50%) scale(2)`
      );
      this.renderer.setStyle(ripple, 'opacity', '0');
    });

    setTimeout(() => {
      if (hostElement.contains(ripple)) {
        this.renderer.removeChild(hostElement, ripple);
      }
    }, this.rippleDuration);
  }
}
